// extracted by mini-css-extract-plugin
export default {"container":"vW-z","title":"wW-z","link":"xW-z"};